<app-entity-transaction-history
  [entityId]="entityId"
  [config]="transactionConfig"
  [serviceAdapter]="dashboardTransactionAdapter"
  [entityIdParam]="'id'"
  [initialSearch]="initialSearch"
  [useRouteParams]="false"
  [hideExchangeType]="true"
  (transactionSelected)="onTransactionSelected($event)"
>
</app-entity-transaction-history>
